import axios from 'axios'

// import { baseUrl } from './urlConfig'
import { message } from 'ant-design-vue';
import router from '../router'
axios.defaults.baseURL = process.env.VUE_APP_REQUEST_URL
axios.defaults.withCredentials = true 
const request = axios.create({
  //设置请求头
    headers:{
      "Content-Type": "application/json;charset=utf-8",
    },
    //设置超时时间
    timeout:30000,
    //返回数据类型
    responseType:'json',
    //跨域
    changeOrigin:true
  })
    /**
   * 请求前拦截
   * 用于处理需要在请求前的操作
   */
  request.interceptors.request.use((config) => { // config是请求的配置
      config.headers.Token = sessionStorage.getItem("Token") ||localStorage.getItem("Token")
    return config
  }, (error) => {
  // 这里写对请求错误做些什么
    return Promise.reject(error)
  })
  /**
   * 请求响应拦截
   * 用于处理需要在请求返回后的操作
   */
  
  request.interceptors.response.use((response) => {
    let res = response.data
    if (["0001002", "0001005", "0001006"].some((item) => item === res.code)) {
      message.warn(res.msg)
      router.push("/login");
      return false;
    }
    return response.data
  }, (error) => {
    // 对响应错误做点什么
    return Promise.reject(error)
  })

  export default request